import { render, staticRenderFns } from "./TheOrganizationNew.vue?vue&type=template&id=080752d8"
import script from "./TheOrganizationNew.vue?vue&type=script&lang=js"
export * from "./TheOrganizationNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports